import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WorkItemFormCleanData.css";

import PropTypes from "prop-types";

function WorkItemFormCleanData({ cleanData }) {
  return (
    <Container className="coreContent">
      {cleanData.map((item, index) => (
        <Row
          className={`form-question${index % 2 === 0 && "-alt"}`}
          key={`${item.id}`}
        >
          <Col>{item.label}</Col>
          <Col>{item.data}</Col>
        </Row>
      ))}
    </Container>
  );
}

WorkItemFormCleanData.propTypes = {
  cleanData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      data: PropTypes.string,
    })
  ).isRequired,
};

export default WorkItemFormCleanData;
